import { createAction } from '@reduxjs/toolkit';

import { SET_APP_LOADED, type AppLoaded } from './types';

export const setAppLoaded = createAction<AppLoaded, typeof SET_APP_LOADED>(SET_APP_LOADED);
